var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56.966,
    viewBox: "0 0 56 56.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}.b{fill:#4c4c4e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.116 4.41)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.454,3.125h4.673a.742.742,0,0,1,.6.3.8.8,0,0,1,.162.662c-.435,2.143-1.825,6.977-5.432,7.418-3.607-.423-5-5.292-5.432-7.418a.8.8,0,0,1,.162-.662.742.742,0,0,1,.6-.3Z",
    transform: "translate(0.715 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.822,3.338,32.085,8a18.4,18.4,0,0,1-4.417,7.383s-3.053-3.969-5.116-3.969-5.116,3.969-5.116,3.969A18.4,18.4,0,0,1,12.994,8l4.263-4.666",
    transform: "translate(-0.383 -3.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.124,13.237a24.877,24.877,0,0,0-.725,6.016v25.58S32.2,46.6,23.609,46.6s-12.79-1.764-12.79-1.764V19.253a24.876,24.876,0,0,0-.725-6.016",
    transform: "translate(-1.439 1.035)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.006,6.644S30.988,8.3,33.649,9.616",
    transform: "translate(4.722 -1.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.767,6.644S10.785,8.3,8.125,9.616",
    transform: "translate(-2.156 -1.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.786,8.75c3.325,3.44,5.969,13.231,5.969,13.231l-5.969,3.528L29.375,21.1",
    transform: "translate(5.585 -0.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.719,8.75C6.393,12.19,3.75,21.981,3.75,21.981l5.969,3.528,3.411-4.41",
    transform: "translate(-3.75 -0.811)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 10.585,
    transform: "translate(21.317 8.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.989,11.932a.682.682,0,1,1-.682-.682A.682.682,0,0,1,21.989,11.932Z",
    transform: "translate(2.397 1.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.989,15.057a.682.682,0,1,1-.682-.682A.682.682,0,0,1,21.989,15.057Z",
    transform: "translate(2.397 2.385)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 55.067,
    height: 56.966
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolo);
export default __webpack_public_path__ + "static/media/Polo.7094b7ef84865e81da28b0a289b6097e.svg";
export { ForwardRef as ReactComponent };